import {
    Button,
    FormControl,
    FormLabel,
    useDisclosure,
    useToast
} from '@chakra-ui/react';
import FormField from '../../../components/fields/FormField';
import FormModal from '../../../components/FormModal';
import FormStack from '../../../components/form-stack';
import SportSelect from 'components/SportSelect';
import { useSelectedOrganization } from 'features/organization/hooks/useSelectedOrganization';
import { InviteCoachToOrganizationDto } from 'models/organization/dto/invite-to-organization.dto';
import { useState } from 'react';
import { translate } from '../../../i18n';
import { SportType } from '../../../models/court/dto/court.dto';
import { useInviteCoachToOrganization } from '../hooks/useInviteCoachToOrganization';

const defaultValues: InviteCoachToOrganizationDto = {
    firstName: '',
    lastName: '',
    sports: [SportType.PADEL],
    organizationId: '',
    email: ''
};
export default function InviteCoachForm() {
    // Scope to the org chosen in the picker, not the admin's home org. The home
    // org is resolved from the caller's own membership, which a superadmin
    // (elevated, non-member) doesn't have — that errored and blocked inviting.
    const selectedOrganization = useSelectedOrganization.use.selectedOrganization();
    const toast = useToast();

    const [formData, setFormData] = useState<InviteCoachToOrganizationDto>(defaultValues);
    const { isOpen, onOpen, onClose } = useDisclosure();


    const closeModal = () => {
        onClose();
        setFormData({ ...defaultValues });
    };

    const handleInputChange = (key: keyof InviteCoachToOrganizationDto, value: any) => {
        setFormData({ ...formData, [key]: value });
    };

    const { mutateAsync: inviteCoachToOrganization, isLoading: isInviting } = useInviteCoachToOrganization(selectedOrganization?.id, closeModal);
    const handleSubmit = () => {
        if (selectedOrganization?.id) {
            inviteCoachToOrganization({
                email: formData.email,
                organizationId: selectedOrganization.id,
                firstName: formData.firstName,
                lastName: formData.lastName,
                sports: formData.sports,
            }).then(() => {
                toast({
                    title: translate('coachs.invite_success'),
                    status: 'success',
                    duration: 4000,
                });
            }).catch(() => {
                toast({
                    title: translate('coachs.invite_error'),
                    status: 'error',
                    duration: 4000,
                });
            });
        } else {
            throw new Error("Organization ID is missing");
        }
    };

    return (
        <>
            <Button colorScheme="brand" onClick={onOpen}>
                {translate('coachs.invite')}
            </Button>
            <FormModal
                isOpen={isOpen}
                onClose={closeModal}
                title={translate('coachs.invite')}
                onSubmit={handleSubmit}
                submitLabel={translate('submit')}
                cancelLabel={translate('cancel')}
                isSubmitting={isInviting}
                size="lg"
            >
                <FormStack>
                    <FormField
                        type="text"
                        label={translate('coachs.firstName')}
                        value={formData.firstName}
                        onChange={(value) => handleInputChange('firstName', value)}
                    />
                    <FormField
                        type="text"
                        label={translate('coachs.lastName')}
                        value={formData.lastName}
                        onChange={(value) => handleInputChange('lastName', value)}
                    />
                    <FormField
                        type="email"
                        label={translate('coachs.email')}
                        value={formData.email}
                        onChange={(value) => handleInputChange('email', value)}
                    />
                    <FormControl>
                        <FormLabel>{translate('event.sport')}</FormLabel>
                        <SportSelect
                            value={formData.sports || []}
                            onChange={(next) => handleInputChange('sports', next)}
                        />
                    </FormControl>
                </FormStack>
            </FormModal>
        </>
    )
}
